module.exports = __webpack_public_path__ + "img/diagnostic.7058461c.svg";